import styled from 'styled-components';

import colors from 'themes/Main';

const { darkBlue, blue } = colors;

export const UnfilledButton = styled.button`
  padding: 0;
  margin: 0;
  background: transparent;
  font-size: ${({ fontSize }) => `${fontSize}px`};
  font-weight: 700;
  color: ${darkBlue};
  text-decoration: underline;
  text-transform: ${({ isUppercase }) => (isUppercase ? 'uppercase' : '')};
  transition: all 0.2s;
  border: 0;

  &:hover {
    color: ${blue};
    opacity: 0.95;
    text-decoration: underline;
  }
`;
